var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{attrs:{"id":"loading"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-content"}},[_c('img',{attrs:{"id":"loading-content-img","src":require("@/assets/images/loading.gif"),"alt":""}})])
}]

export { render, staticRenderFns }